import React from 'react';
import { Thermometer } from "lucide-react";
import GenericRawDataChart, { RawDataChartConfig, TemperatureAnnotation } from './GenericRawDataChart';

interface CompressorInletOutletPowerChartProps {
  installationId: string;
  organizationId: number;
  plotStartTime: string;
  plotEndTime: string;
  locationName: string;
  sensorKitSerialNumber: string;
  annotations?: TemperatureAnnotation[]; // Array of annotation lines to display
  showAmbient?: boolean; // Whether to show ambient temperature
  onSuccess?: (hasData: boolean) => void; // Callback to notify parent of success/failure
}

const CompressorInletOutletPowerChart: React.FC<CompressorInletOutletPowerChartProps> = ({
  installationId,
  organizationId,
  plotStartTime,
  plotEndTime,
  locationName,
  sensorKitSerialNumber,
  annotations = [],
  showAmbient = false,
  onSuccess
}) => {

  const config: RawDataChartConfig = {
    title: 'Compressor Inlet/Outlet Temperature & Power',
    icon: Thermometer,
    showInlet: true,
    showOutlet: true,
    showAmbient: showAmbient,
    showPower: true,
    annotations: annotations,
    downloadFileName: 'compressor-inlet-outlet-power'
  };

  return (
    <GenericRawDataChart
      installationId={installationId}
      organizationId={organizationId}
      plotStartTime={plotStartTime}
      plotEndTime={plotEndTime}
      locationName={locationName}
      sensorKitSerialNumber={sensorKitSerialNumber}
      config={config}
      onSuccess={onSuccess}
    />
  );
};

export default CompressorInletOutletPowerChart;
